import { T } from "../constants";

export default function Header({ search, onSearchChange }) {
  return (
    <div style={{
      background: T.moss,
      padding: "2.5rem 2rem 1.5rem",
      position: "relative", overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", bottom: "-20px", right: "16px",
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "14rem", lineHeight: 1,
        color: "rgba(240,247,235,0.04)",
        pointerEvents: "none", userSelect: "none",
      }}>❧</div>

      <div style={{
        fontSize: "0.68rem", letterSpacing: "0.22em",
        textTransform: "uppercase", color: "rgba(240,247,235,0.4)",
        marginBottom: "0.4rem",
      }}>
        Herbal remedies
      </div>

      <h1 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "clamp(2.4rem, 5vw, 3.2rem)",
        fontStyle: "italic", fontWeight: 400,
        color: T.headerText, lineHeight: 1, margin: "0 0 0.3rem",
      }}>
        Earthy <span style={{ color: T.lime, fontStyle: "normal" }}>Mujer</span>
      </h1>

      <p style={{
        color: "rgba(240,247,235,0.45)",
        fontSize: "0.85rem", margin: "0 0 1.5rem", lineHeight: 1.5,
      }}>
        Remedies from personal practice & community
      </p>

      <div style={{
        maxWidth: "520px",
        borderBottom: "0.5px solid rgba(240,247,235,0.25)",
        paddingBottom: "6px",
        display: "flex", alignItems: "center", gap: "8px",
      }}>
        <span style={{ color: "rgba(240,247,235,0.35)", fontSize: "0.9rem" }}>⌕</span>
        <input
          type="text"
          placeholder="Search by name, ingredient, or property (e.g. sleep, immune)..."
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          style={{
            flex: 1, border: "none", background: "transparent",
            fontSize: "0.875rem", color: T.headerText,
            fontFamily: "'DM Sans', sans-serif",
          }}
        />
      </div>
    </div>
  );
}
